module.exports = __webpack_public_path__ + "img/Logo-cloud.ecaa84f4.png";